// extracted by mini-css-extract-plugin
export var columnList = "_dp-0";